// extracted by mini-css-extract-plugin
export default {"container":"styles_container__27WUO","form":"styles_form__aC-dv","item":"styles_item__yVo52","label":"styles_label__OCDhY"};